import src from "IMAGE";
export default { src, width: 551, height: 116, blurWidth: 0, blurHeight: 0};
